export const SYSTEM_PROMPT = "Sei un giurista molto esperto e devi controllare le seguenti sentenze.";
export const SENTENZE_PROMPT = "Esamina la seguente sentenza {sentenza}";